module.exports = __webpack_public_path__ + "img/plus_his.0a57c3cb.svg";